const LocalOffer = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4892 6.755L7.23919 1.505C7.02919 1.295 6.73752 1.16666 6.41669 1.16666H2.33335C1.69169 1.16666 1.16669 1.69166 1.16669 2.33333V6.41666C1.16669 6.7375 1.29502 7.02916 1.51085 7.245L6.76085 12.495C6.97085 12.705 7.26252 12.8333 7.58335 12.8333C7.90419 12.8333 8.19585 12.705 8.40585 12.4892L12.4892 8.40583C12.705 8.19583 12.8334 7.90416 12.8334 7.58333C12.8334 7.2625 12.6992 6.965 12.4892 6.755ZM3.20835 4.08333C2.72419 4.08333 2.33335 3.6925 2.33335 3.20833C2.33335 2.72416 2.72419 2.33333 3.20835 2.33333C3.69252 2.33333 4.08335 2.72416 4.08335 3.20833C4.08335 3.6925 3.69252 4.08333 3.20835 4.08333Z"
        fill="#F76707"
      />
    </svg>
  );
};

export default LocalOffer;
